// Create a class for the element
class ComponentWineriesOverview extends HTMLElement {
  static observedAttributes = ["char"];

  constructor() {
    super();
  }

  connectedCallback() {
    this.currentFilter = this.getAttribute('char');
    this.charNav = this.querySelector('[charNav]');
    this.entries = this.querySelectorAll('.vineyard-card');
    this.showAll = this.querySelector('[char_value="show_all"]');
    if (this.entries.length > 0 ) {
      this.updateCharFilter();
      this.filterEntries();
    }

    //display toggle
    this.displayToggles = this.querySelectorAll('[toggle]');
    this.entriesContainer = this.querySelector('.entries');
    this.displayToggles.forEach((toggle)=> {
      toggle.onclick = ()=> {
        const toggleAttribute = toggle.getAttribute('toggle');
        if(toggleAttribute == 'list'){
          this.entriesContainer.setAttribute('list_style', '');
        } else {
          this.entriesContainer.removeAttribute('list_style');
        }
      }
    })
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if ( oldValue !== newValue ) {
      this.currentFilter = newValue;
      this.setActiveFitler(newValue)
      this.filterEntries();
    }
  }

  filterEntries(){
    //filter entries by char
    if(this.currentFilter == 'show_all'){ // change to 'none'
      console.log(this.entries)
      this.entries.forEach((entry) => {
        entry.classList.remove('hidden');
      })
    } else {
      this.entries.forEach((entry)=> {
        console.log(entry)
        if(entry.getAttribute('name').toUpperCase().charAt(0) != this.getAttribute('char')){
          entry.classList.add('hidden');
        } else {
          entry.classList.remove('hidden');
        }
      })
    }
  }

  updateCharFilter(){
    // alphabet index helpers
    const alphabetList = [
      [1, "A", "Ä"],
      [2, "B"],
      [3, "C"],
      [4, "D"],
      [5, "E"],
      [6, "F"],
      [7, "G"],
      [8, "H"],
      [9, "I"],
      [10, "J"],
      [11, "K"],
      [12, "L"],
      [13, "M"],
      [14, "N"],
      [15, "O", "Ö"],
      [16, "P"],
      [17, "Q"],
      [18, "R"],
      [19, "S"],
      [20, "T"],
      [21, "U", "Ü"],
      [22, "V"],
      [23, "W"],
      [24, "X"],
      [25, "Y"],
      [26, "Z"]
    ]
    //map to render availabel chars
    const availabelCharList = {
      1: "-",
      2: "-",
      3: "-",
      4: "-",
      5: "-",
      6: "-",
      7: "-",
      8: "-",
      9: "-",
      10: "-",
      11: "-",
      12: "-",
      13: "-",
      14: "-",
      15: "-",
      16: "-",
      17: "-",
      18: "-",
      19: "-",
      20: "-",
      21: "-",
      22: "-",
      23: "-",
      24: "-",
      25: "-",
      26: "-"
    };

    for( let entry of this.entries){
        const name = entry.getAttribute('name');
        if( name ){
            const char = name.toUpperCase().charAt(0);
            if(!!char){
              //find alphabete index & overwrite index in availableCharList
              const charValue = char.toUpperCase();
              const mappingHelper = alphabetList.find((val)=> val.includes(charValue));
              if(!!mappingHelper){
                const index = mappingHelper[0];
                const charToAdd = mappingHelper[1];
                availabelCharList[index] = charToAdd;
              } else {
                console.error(`No mapping helper found for ${charValue}`);
              }
            }
        }
    }

    const charListArray = Object.entries(availabelCharList);

    for( let charArray of charListArray ){
        const char = charArray[1];
        const charNode = document.createElement("button");
        if(char == '-'){
          charNode.classList.add('disabled');
          charNode.classList.add('only_large');
        }
        charNode.setAttribute("char_value", char);
        charNode.classList.add("char");
        if( char === this.getAttribute('char') ){
            charNode.classList.add("active");
        }
        charNode.innerHTML = char;
        if(char != '-'){
          charNode.addEventListener("click", () => this.setAttribute('char', char));
        }
        this.charNav.appendChild(charNode);
    }
    if(!!this.showAll){
      this.showAll.onclick = ()=>{
        this.setAttribute('char', 'show_all');
      }
    }
  }
  setActiveFitler( char ) {
      this.querySelectorAll('#char_list button').forEach( button => {
          if ( button.getAttribute('char_value') === char ) {
              button.classList.add('active')
          } else {
              button.classList.remove('active');
          }
      })
  }
}

customElements.define("component-wineries-overview", ComponentWineriesOverview);
